import { Platform, StyleSheet, type TextStyle, type ViewStyle } from 'react-native';
import { appTheme, type ThemeColors } from '../../../../shared/theme';
import { androidResolveShadow, androidScaleFont } from '../../../../shared/theme/sharedStyles';
import { DASH_STUDIO_RADIUS } from '../../../../shared/theme/studio/dashboardConstants';

/** Soft shadow for nested strip / address tiles so they lift off the outer shell. */
export function dashboardSet2NestedTileShadow(colors: ThemeColors): ViewStyle {
  if (Platform.OS === 'android') {
    return {
      elevation: 2,
      shadowColor: colors.shadowColor ?? '#0F172A',
    };
  }
  return {
    shadowColor: colors.shadowColor ?? '#0F172A',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.11,
    shadowRadius: 5,
  };
}

/** Outer set2 dashboard card shell — matches set1 studio depth / radius. */
export function dashboardSet2CardShell(colors: ThemeColors): ViewStyle {
  const ios_shadow: ViewStyle = {
    shadowColor: colors.shadowColor ?? '#0F172A',
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.07,
    shadowRadius: 10,
  };
  const android_shadow: ViewStyle = { elevation: 2 };
  return {
    backgroundColor: colors.surface,
    borderRadius: DASH_STUDIO_RADIUS,
    overflow: 'visible',
    ...androidResolveShadow(Platform.OS === 'android' ? android_shadow : ios_shadow),
  };
}

export function dashboardSet2SectionLabelStyle(colors: ThemeColors): TextStyle {
  return {
    fontSize: androidScaleFont(11),
    fontWeight: '800',
    letterSpacing: 1.1,
    textTransform: 'uppercase',
    color: colors.textLight,
    marginBottom: appTheme.spacing.sm,
    marginStart: appTheme.spacing.xxs,
  };
}

export const dashboardSet2SectionStyles = StyleSheet.create({
  secondarySection: {
    marginTop: appTheme.spacing.sm,
  },
  tertiarySection: {
    marginTop: appTheme.spacing.xs,
  },
});
